import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faBox,
  faPlusCircle,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./MisAlimentos.css";
import AddControlAlimentoForm from "../Granja/Add/Forms/AddControlAlimentoForm/AddControlAlimentoForm";
import AddAlimentoForm from "../Granja/Add/Forms/AddAlimentoForm/AddAlimentoForm";
import DashboardButtons from "../Granja/DashboardButtons/DashboardButtons";
import { useShoppingContext } from "../context/ShoppingContext";

const MisAlimentos = () => {
  const {
    alimentos,
    setAlimentos,
    setShowAddAlimento,
    setShowAddControlAlimentos,
    fetchAlimentos,
    showAddControlAlimentos,
    showAddAlimento,
    setSelectedAlimento, // Agregamos esto del contexto
    renderDateTitle,
  } = useShoppingContext();
  const navigate = useNavigate();

  useEffect(() => {
    fetchAlimentos(); // Cargar los alimentos del usuario autenticado
  }, [fetchAlimentos]);

  // Manejar la eliminación de un alimento
  const handleDeleteAlimento = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/alimentos/${id}`)
      .then((response) => {
        setAlimentos((prevAlimentos) =>
          prevAlimentos.filter((alimento) => alimento.id !== id)
        );
        console.log(response.data.message);
      })
      .catch((error) => console.error("Error eliminando alimento:", error));
  };

  // Función para calcular el número de sacos
  const calcularSacos = (cantidad, pesoSaco) => {
    if (!pesoSaco || pesoSaco <= 0) return null;
    return Math.floor(cantidad / pesoSaco);
  };

  if (alimentos.length === 0) {
    return <p>No hay alimentos registrados.</p>;
  }

  return (
    <div className="content-container">
      <DashboardButtons />
      <div className="alimento-grid-container">
        {alimentos.map((alimento, index) => {
          const sacos = calcularSacos(alimento.cantidad, alimento.pesoSaco);
          const fechaUltimoPedido = renderDateTitle(alimento.ultimoPedido);

          return (
            <div
              className="alimento-item-card card shadow-sm"
              key={alimento.id}
            >
              <div className="alimento-card-body">
                <h5 className="alimento-card-title">{alimento.nombre}</h5>
                <p className="alimento-card-text">
                  Cantidad: {alimento.cantidad} kg
                </p>
                {sacos !== null && (
                  <p className="alimento-card-text">
                    <FontAwesomeIcon icon={faBox} /> Número de sacos: {sacos}
                  </p>
                )}
                <div className="alimento-card-row">
                  <span className="alimento-card-label">Último Pedido:</span>
                  <span className="alimento-card-value">
                    {fechaUltimoPedido}
                  </span>
                </div>
              </div>
              <div className="alimento-card-footer d-flex justify-content-between">
                {/* Botón para sumar alimento */}
                <button
                  className="alimento-btn-add"
                  onClick={() => {
                    setSelectedAlimento(alimento); // Seleccionar el alimento
                    setShowAddAlimento(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Sumar Alimento
                </button>

                {/* Botón para alimentar aves */}
                <button
                  className="alimento-btn-feed"
                  onClick={() => {
                    setSelectedAlimento(alimento); // Seleccionar el alimento
                    setShowAddControlAlimentos(true);
                  }}
                >
                  <FontAwesomeIcon icon={faUtensils} /> Alimentar Aves
                </button>

                {/* Botón para editar el alimento */}
                <button
                  className="alimento-btn-edit"
                  onClick={() => navigate(`/edit-alimento/${alimento.id}`)}
                >
                  <FontAwesomeIcon icon={faEdit} /> Editar
                </button>

                {/* Botón para eliminar el alimento */}
                <button
                  className="alimento-btn-delete"
                  onClick={() => handleDeleteAlimento(alimento.id)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {showAddControlAlimentos && <AddControlAlimentoForm />}

      {showAddAlimento && <AddAlimentoForm />}
    </div>
  );
};

export default MisAlimentos;
